import SetToken from './storage/Cookie/SetToken'
import GetToken from './storage/Cookie/GetToken'
import HasToken from './storage/Cookie/HasToken'
import DeleteToken from './storage/Cookie/DeleteToken'
import SetLocalToken from './storage/Local/SetToken'
import DeleteLocalToken from './storage/Local/DeleteToken'
import SetUser from './storage/Local/SetUser'
import GetUser from './storage/Local/GetUser'
import DeleteUser from './storage/Local/DeleteUser'

export const Authenticate = (token, user = null) => {
    SetToken(token)
    SetLocalToken(token)
    if (!!user) {
        SetUser(user)
    }
}

export const UnAuthenticate = () => {
    DeleteToken()
    DeleteLocalToken()
    DeleteUser()
}

export const IsAuthenticated = () => {
    return HasToken()
}

export const User = () => {
    return GetUser()
}

export const Token = () => {
    return GetToken()
}
